import React from "react";
import Button from "./button";
import Label from "./label";
import Field from "./field";
import Actions from "./actions";
import Input from "./input";
import Select from "./select";
import Textarea from "./textarea";
import Link from "./link";
import Text from "./text";
import Notice from "./notice";
import Card from "./card";
import Table from "./table";
import TableHead from "./table_head";
import TableBody from "./table_body";
import TableRow from "./table_row";
import TableCell from "./table_cell";

import { Text as GroundworkUiUiText } from "../../groundworkui-ui";

const UiKitPreview = ({ uiKitConfiguration }) => {
  return (
    <div className="flex flex-col gap-12">
      <div>
        <GroundworkUiUiText type="h3">Text</GroundworkUiUiText>

        <div className="flex flex-col gap-2">
          <Text uiKitConfiguration={uiKitConfiguration} type="h1">
            H1 Text
          </Text>
          <Text uiKitConfiguration={uiKitConfiguration} type="h2">
            H2 Text
          </Text>
          <Text uiKitConfiguration={uiKitConfiguration} type="h3">
            H3 Text
          </Text>
          <Text uiKitConfiguration={uiKitConfiguration} type="h4">
            H4 Text
          </Text>
          <Text uiKitConfiguration={uiKitConfiguration} type="large">
            Large Text
          </Text>
          <Text uiKitConfiguration={uiKitConfiguration} type="medium">
            Medium Text
          </Text>
          <Text uiKitConfiguration={uiKitConfiguration} type="small">
            Small Text
          </Text>
          <Text uiKitConfiguration={uiKitConfiguration} type="large" bold>
            Large Text
          </Text>
          <Text uiKitConfiguration={uiKitConfiguration} type="medium" bold>
            Medium Text
          </Text>
          <Text uiKitConfiguration={uiKitConfiguration} type="small" bold>
            Small Text
          </Text>
        </div>
      </div>
      <div>
        <GroundworkUiUiText type="h3">Buttons</GroundworkUiUiText>

        <div className="flex gap-3">
          <Button uiKitConfiguration={uiKitConfiguration} type="primary">
            Primary Button
          </Button>
          <Button uiKitConfiguration={uiKitConfiguration} type="success">
            Success Button
          </Button>
          <Button uiKitConfiguration={uiKitConfiguration} type="info">
            Info Button
          </Button>
          <Button uiKitConfiguration={uiKitConfiguration} type="warning">
            Warning Button
          </Button>
          <Button uiKitConfiguration={uiKitConfiguration} type="danger">
            Danger Button
          </Button>
          <Button uiKitConfiguration={uiKitConfiguration} type="ghost">
            Ghost Button
          </Button>
        </div>
      </div>

      <div>
        <GroundworkUiUiText type="h3">Forms</GroundworkUiUiText>
        <form>
          <Field>
            <Label uiKitConfiguration={uiKitConfiguration}>Label 1</Label>
            <Input
              uiKitConfiguration={uiKitConfiguration}
              type="text"
              placeholder="Text is a text input"
            />
          </Field>

          <Field>
            <Label uiKitConfiguration={uiKitConfiguration}>Label 2</Label>
            <Select uiKitConfiguration={uiKitConfiguration}>
              <option>Please select...</option>
              <option value="1">Option 1</option>
              <option value="2">Option 2</option>
              <option value="3">Option 3</option>
            </Select>
          </Field>

          <Field>
            <Label uiKitConfiguration={uiKitConfiguration}>Label 3</Label>
            <Textarea
              uiKitConfiguration={uiKitConfiguration}
              rows={5}
              placeholder="This is a text area"
            ></Textarea>
          </Field>

          <Actions>
            <Button uiKitConfiguration={uiKitConfiguration} type="primary">
              Submit
            </Button>
            <Button uiKitConfiguration={uiKitConfiguration} type="ghost">
              Cancel
            </Button>
          </Actions>
        </form>
      </div>

      <div>
        <GroundworkUiUiText type="h3">Links</GroundworkUiUiText>
        <Link uiKitConfiguration={uiKitConfiguration} href="#">
          This is a link
        </Link>
      </div>

      <div>
        <GroundworkUiUiText type="h3">Notices</GroundworkUiUiText>

        <div className="flex flex-col gap-2">
          <Notice uiKitConfiguration={uiKitConfiguration} type="info">
            This is a info notice
          </Notice>
          <Notice uiKitConfiguration={uiKitConfiguration} type="danger">
            This is an danger notice
          </Notice>
          <Notice uiKitConfiguration={uiKitConfiguration} type="success">
            This is a success notice
          </Notice>
          <Notice uiKitConfiguration={uiKitConfiguration} type="warning">
            This is a warning notice
          </Notice>
        </div>
      </div>

      <div>
        <GroundworkUiUiText type="h3">Cards</GroundworkUiUiText>

        <Card uiKitConfiguration={uiKitConfiguration}>This is a card</Card>
      </div>

      <div>
        <GroundworkUiUiText type="h3">Tables</GroundworkUiUiText>

        <Table uiKitConfiguration={uiKitConfiguration}>
          <TableHead uiKitConfiguration={uiKitConfiguration}>
            <TableRow uiKitConfiguration={uiKitConfiguration}>
              <TableCell uiKitConfiguration={uiKitConfiguration}>
                Header 1
              </TableCell>
              <TableCell uiKitConfiguration={uiKitConfiguration}>
                Header 2
              </TableCell>
              <TableCell uiKitConfiguration={uiKitConfiguration}>
                Header 3
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody uiKitConfiguration={uiKitConfiguration}>
            <TableRow uiKitConfiguration={uiKitConfiguration}>
              <TableCell uiKitConfiguration={uiKitConfiguration}>
                Row 1 Cell 1
              </TableCell>
              <TableCell uiKitConfiguration={uiKitConfiguration}>
                Row 1 Cell 2
              </TableCell>
              <TableCell uiKitConfiguration={uiKitConfiguration}>
                Row 1 Cell 3
              </TableCell>
            </TableRow>
            <TableRow uiKitConfiguration={uiKitConfiguration}>
              <TableCell uiKitConfiguration={uiKitConfiguration}>
                Row 2 Cell 1
              </TableCell>
              <TableCell uiKitConfiguration={uiKitConfiguration}>
                Row 2 Cell 2
              </TableCell>
              <TableCell uiKitConfiguration={uiKitConfiguration}>
                Row 2 Cell 3
              </TableCell>
            </TableRow>
            <TableRow uiKitConfiguration={uiKitConfiguration}>
              <TableCell uiKitConfiguration={uiKitConfiguration}>
                Row 3 Cell 1
              </TableCell>
              <TableCell uiKitConfiguration={uiKitConfiguration}>
                Row 3 Cell 2
              </TableCell>
              <TableCell uiKitConfiguration={uiKitConfiguration}>
                Row 3 Cell 3
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

export default UiKitPreview;
